"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlModalImage = void 0;
var _react = require("react");
var _bem = require("./bem");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Modal Image
 *
 * @description
 * Show an image on the modal
 *
 */
var GlModalImageCore = function GlModalImageCore(_ref) {
  var alt = _ref.alt,
    src = _ref.src,
    title = _ref.title,
    position = _ref.position;
  return typeof src === 'string' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _bem.bemModal)('main-img'),
    style: position !== 'top' ? {
      backgroundImage: "url('".concat(src, "')")
    } : {},
    children: position === 'top' && /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      alt: alt,
      src: src,
      title: title
    })
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _bem.bemModal)('main-img'),
    children: src
  });
};
var GlModalImage = exports.GlModalImage = /*#__PURE__*/(0, _react.memo)(GlModalImageCore);